module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M26 0H6C2.68 0 0 2.68 0 6v20c0 3.32 2.68 6 6 6h20c1.106 0 2-.894 2-2V10c0-1.106-.894-2-2-2h-3a1 1 0 0 0-1 1v10.582c0 .554-.348.718-.778.372L19 17.574l-2.222 2.298c-.43.346-.778.18-.778-.372V10c0-1.106-.894-2-2-2H6c-1.1 0-2-.9-2-2s.9-2 2-2h21a1 1 0 0 0 1-1V2c0-1.106-.894-2-2-2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/book-1.js
// module id = 1014
// module chunks = 14